/** Quiz Group API */
import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'
import type {
  QuizGroupSummary,
  QuizGroupDetail,
  QuizGroupMetadataUpdate,
} from '@/types/quizSet'

export const getQuizGroups = async (activeOnly = false): Promise<QuizGroupSummary[]> => {
  const response = await apiClient.get<ApiResponse<QuizGroupSummary[]>>('/quiz-groups', {
    params: { active: activeOnly },
  })
  return response.data.data!
}

/** 그룹 상세(items 해석). items[].quiz.quizId 정규화 후 파싱. */
export const getQuizGroup = async (id: number): Promise<QuizGroupDetail> => {
  const response = await apiClient.get<string>(`/quiz-groups/${id}`, {
    responseType: 'text',
  })
  const normalized = response.data.replace(/"quizId"\s*:\s*(\d+)/g, '"quizId":"$1"')
  const parsed = JSON.parse(normalized) as ApiResponse<QuizGroupDetail>
  if (!parsed.data) throw new Error('Invalid quiz group response')
  return parsed.data
}

export const updateQuizGroup = async (
  id: number,
  request: QuizGroupMetadataUpdate,
): Promise<QuizGroupDetail> => {
  const response = await apiClient.put<ApiResponse<QuizGroupDetail>>(`/quiz-groups/${id}`, request)
  return response.data.data!
}

export const deleteQuizGroup = async (id: number): Promise<void> => {
  await apiClient.delete(`/quiz-groups/${id}`)
}

export const reorderQuizGroups = async (groupIds: number[]): Promise<void> => {
  await apiClient.put('/quiz-groups/reorder', { groupIds })
}
